module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Norman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John Norman is the creator of the Gorean Saga, the longest-running series of adventure novels in science fiction history. He is also the author of the science fiction series the Telnarian Histories, as well as "), _c('I', [_vm._v("Ghost Dance")]), _vm._v(", "), _c('I', [_vm._v("Time Slave")]), _vm._v(", "), _c('I', [_vm._v("The Totems of Abydos")]), _vm._v(", "), _c('I', [_vm._v("Imaginative Sex")]), _vm._v(", and "), _c('I', [_vm._v("Norman Invasions")]), _vm._v(". Norman is married and has three children.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fk9QfI/tc-custom/9781504089500.jpg?1722481919505",
      "alt": "This image is the cover for the book Treasure of Gor, Gorean Saga"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Treasure of Gor, Gorean Saga\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A brilliant woman’s dangerous discovery on Earth leads to her enslavement on the planet Gor in this long-running sci-fi fantasy series.")])]), _c('p', [_vm._v(" In a remote corner of the American southwest, there is a small, private observatory. To most of the staff, it is just another stargazing facility. But a select few know its true function as a liaison point between two alien worlds: the decimated planet of the warlike Kurii, and the planet Gor, which the Kurii now covet.  ")]), _vm._v(" When the young scientist Agnes Morrison Atherton comes across an unintelligible file containing mysterious coordinates, she decides to decode them—and discovers two large, spherical, seemingly artificial objects in the asteroid belt. But it seems that Atherton’s remarkable discovery is less than welcome. Abducted and drugged, she awakens to find herself on the planet Gor—being sold as a Gorean slave girl.\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0